var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRibbonGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ribbon gold (1) 1",
    clipPath: "url(#clip0_578_401938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cert-gold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ribbon-gold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0253 55.7703L19.9521 51.6954V33.2988H29.6495V54.7933C29.6734 55.6035 28.7896 56.1516 28.0253 55.7703Z",
    fill: "#009AD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9027 55.7703L19.9759 51.6954V33.2988H10.2546V54.7933C10.2546 55.6035 11.1623 56.1516 11.9027 55.7703Z",
    fill: "#00ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2546 27.7944V35.6821C10.2546 36.5161 11.7355 37.3978 12.5954 37.3978L15.3899 37.9221L17.7785 39.2804C19.1399 40.0668 20.788 40.0668 22.1494 39.2804L24.5379 37.9221L27.3325 37.3978C28.1685 37.3978 29.6733 36.6115 29.6733 35.6821V27.7944H10.2546Z",
    fill: "#007BAA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4631 16.8564L31.1303 4.13131C30.3421 2.77301 28.909 1.93896 27.3326 1.93896H12.5954C11.019 1.93896 9.58592 2.77301 8.79771 4.13131L1.48886 16.8564C0.700653 18.2147 0.700653 19.859 1.48886 21.2173L8.79771 33.9185C9.58592 35.2768 11.019 36.1109 12.5954 36.1109H27.3326C28.909 36.1109 30.3421 35.2768 31.1303 33.9185L38.4392 21.2173C39.2274 19.859 39.2274 18.1909 38.4631 16.8564Z",
    fill: "#FEBF00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7786 0.580704L5.04777 7.87262C3.68632 8.659 2.85034 10.0888 2.85034 11.6616V26.3645C2.85034 27.9373 3.68632 29.3671 5.04777 30.1535L17.7786 37.4454C19.14 38.2318 20.7881 38.2318 22.1495 37.4454L34.8803 30.1535C36.2418 29.3671 37.0777 27.9373 37.0777 26.3645V11.6616C37.0777 10.0888 36.2418 8.659 34.8803 7.87262L22.1495 0.580704C20.7881 -0.181849 19.14 -0.181849 17.7786 0.580704Z",
    fill: "#FEBF00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4918 6.51437L31.1303 4.13139C30.3421 2.77309 28.909 1.93905 27.3326 1.93905H24.538L22.1495 0.580754C20.7881 -0.205629 19.14 -0.205629 17.7785 0.580754L15.39 1.93905H12.5954C11.019 1.93905 9.58592 2.77309 8.79771 4.13139L7.43626 6.51437L5.04775 7.87267C3.68629 8.65905 2.85031 10.0888 2.85031 11.6616V14.4497L1.48886 16.8327C0.700653 18.191 0.700653 19.8352 1.48886 21.1935L2.85031 23.5765V26.3646C2.85031 27.9373 3.68629 29.3671 5.04775 30.1535L7.43626 31.5118V31.5356L32.4918 6.51437Z",
    fill: "#FFD03B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3916 19.0252C8.3916 25.4116 13.5747 30.5827 19.9759 30.5827C26.3771 30.5827 31.5602 25.4116 31.5602 19.0252C31.5602 12.6388 26.3771 7.46777 19.9759 7.46777C13.5747 7.46777 8.3916 12.6388 8.3916 19.0252Z",
    fill: "url(#paint0_linear_578_401938)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.976 9.68369C25.7084 9.68369 30.3899 14.3305 30.6287 19.5016C30.6287 19.3347 30.6287 19.1918 30.6287 19.025C30.6287 13.139 25.8517 8.37305 19.9521 8.37305C14.0525 8.37305 9.29932 13.139 9.29932 19.025C9.29932 19.1918 9.29932 19.3347 9.3232 19.5016C9.56205 14.3305 14.2197 9.68369 19.976 9.68369Z",
    fill: "#F98800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.976 29.6767C14.0763 29.6767 9.29932 24.9108 9.29932 19.0248C9.29932 13.1388 14.0763 8.37288 19.976 8.37288C25.8756 8.37288 30.6526 13.1388 30.6526 19.0248C30.6526 24.9108 25.8517 29.6767 19.976 29.6767ZM19.976 6.51416C13.0493 6.51416 7.43628 12.1142 7.43628 19.0248C7.43628 25.9354 13.0493 31.5354 19.976 31.5354C26.9027 31.5354 32.5157 25.9354 32.5157 19.0248C32.4918 12.1142 26.8788 6.51416 19.976 6.51416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.358 13.2582L21.9584 16.5229C22.03 16.642 22.1494 16.7374 22.2927 16.7612L25.8994 17.2855C26.2577 17.3331 26.401 17.7859 26.1383 18.0242L23.5348 20.5501C23.4392 20.6455 23.3915 20.7884 23.4153 20.9314L24.0364 24.5059C24.108 24.8633 23.7259 25.1255 23.4153 24.9586L20.1909 23.2667C20.0714 23.1952 19.9042 23.1952 19.7848 23.2667L16.5603 24.9586C16.2498 25.1255 15.8676 24.8633 15.9393 24.5059L16.5603 20.9314C16.5842 20.7884 16.5364 20.6455 16.4409 20.5501L13.7896 18.0242C13.5269 17.762 13.6702 17.3331 14.0285 17.2855L17.6351 16.7612C17.7785 16.7374 17.8979 16.642 17.9695 16.5229L19.5698 13.2582C19.737 12.9484 20.1909 12.9484 20.358 13.2582Z",
    fill: "#FFD03B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9854 17.0468L24.5857 16.6417C24.6574 16.6179 24.6574 16.5225 24.5857 16.4987L22.9854 16.0936C22.7943 16.0459 22.6749 15.903 22.6272 15.7362L22.2211 14.1396C22.1972 14.0681 22.1017 14.0681 22.0778 14.1396L21.6717 15.7362C21.624 15.9268 21.4807 16.0459 21.3135 16.0936L19.7132 16.4987C19.6415 16.5225 19.6415 16.6179 19.7132 16.6417L21.3135 17.0468C21.5046 17.0944 21.624 17.2374 21.6717 17.4042L22.0778 19.0008C22.1017 19.0723 22.1972 19.0723 22.2211 19.0008L22.6272 17.4042C22.651 17.2136 22.7943 17.0706 22.9854 17.0468Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_578_401938",
    x1: 19.9663,
    y1: 7.4765,
    x2: 19.9663,
    y2: 30.5769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9A02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_401938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.2162,
    height: 56,
    fill: "white",
    transform: "translate(0.891846)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonGold);
export default __webpack_public_path__ + "static/media/ribbonGold.2c52d9f65360fd73367881db8d5b1ece.svg";
export { ForwardRef as ReactComponent };